import { selectNewFilter } from './filtering';

export default (from_search) => {
  const prefix = (from_search) ? 'overlay-search-' : '';

  $(document).on('click', `[data-${prefix}clear-all-filters]`, async () => {
    if ($(`[data-${prefix}filter-options] [data-clickable-option].active`).length === 0 && $(`[data-${prefix}sort-by] input[value="manual"]`).prop('checked') === true) {
      return;
    }

    $(`[data-${prefix}filter-options] [data-clickable-option]`).removeClass('active');
    $(`[data-${prefix}selected-filters] [data-${prefix}selected-filters-item]`).remove();
    $(`[data-${prefix}selected-filters]`).removeClass('active');
    $(`[data-${prefix}clickable-option-li]`).removeClass('active');
  
    // Sorting
    $(`[data-${prefix}sort-by] input[value="manual"]`).prop('checked', true);
    $(`[data-mobile-${prefix}filter-sorting] input[value="manual"]`).prop('checked', true);
  
    await selectNewFilter();
  });
  // [ADA]
  $(document).on('keypress', `[data-${prefix}clear-all-filters]`, (e) => {
    const key = e.which;
    console.log('key', key);
  
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });
  
  // Clicking a selected option removes it and unselect the associated filter
  $(document).on('click', `[data-${prefix}selected-filters-item]`, async (e) => {
    const $item = $(e.currentTarget);
    const selected_value = $item.data('selected-filters-value');
    const option_short_value = $item.data(`${prefix}selected-filters-short-value`);
    const selected_type = $item.data(`${prefix}selected-filters-type`);
  
    // Select/unselect desktop/mobile options
    const $all_same_items = $(`[data-${prefix}filter-options-type="${selected_type}"]`).find(`[data-option-value="${selected_value}"]`);
  
    _.each($all_same_items, (all_same_item) => {
      $(all_same_item).removeClass('active');
      $(all_same_item).parent().removeClass('active');
    });
  
    // Unselect all similar options
    const $all_similar_options = $(`[data-${prefix}filter-options-type="${selected_type}"]`).find(`[data-option-short-value="${option_short_value}"]`);
    _.each($all_similar_options, (all_similar_option) => {
      if ($(all_similar_option).data('master-option') !== true) {
        $(all_similar_option).removeClass('active');
        $(all_similar_option).parent().removeClass('active');
      }
    });
  
    // Remove the selected filter item and all related filter items
    // console.log('remove ', `[data-${prefix}selected-filters-item][data-${prefix}selected-filters-type="${selected_type}"][data-selected-filters-value="${selected_value}"]`);
    $(`[data-${prefix}selected-filters-item][data-${prefix}selected-filters-type="${selected_type}"][data-selected-filters-value="${selected_value}"]`).remove();
  
    // // Desktop selected filters bar
    // if ($(`[data-${prefix}selected-filters] [data-${prefix}selected-filters-item]`).length) {
    //   $(`[data-${prefix}selected-filters]`).addClass('active');
    // } else {
    //   $(`[data-${prefix}selected-filters]`).removeClass('active');
    // }

    // Hide the list if no filters selected
    // console.log('~~~~~', $(`[data-${prefix}selected-filters]`).length, `[data-${prefix}selected-filters]`)
    const $selected_filters = $(`[data-${prefix}selected-filters]`).first();
    if ($selected_filters.find(`[data-${prefix}selected-filters-item]`).length === 0) {
      $(`[data-${prefix}selected-filters]`).removeClass('active');
    } else {
      $(`[data-${prefix}selected-filters]`).addClass('active');
    }
      
    await selectNewFilter();
  });
  // [ADA]
  $(document).on('keypress', `[data-${prefix}selected-filters-item]`, (e) => {
    const key = e.which;
    // console.log('key', key);
  
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });
};
